import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
/**
 * 表单控件容器
 *
 * @ReactComponent
 */
var FormControlWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: ", ";\n  min-height: 40px;\n  box-sizing: border-box;\n  padding: 0;\n  ", ";\n"], ["\n  display: ", ";\n  flex-direction: ", ";\n  min-height: 40px;\n  box-sizing: border-box;\n  padding: 0;\n  ", ";\n"])), function (props) { return (props.inline ? 'inline-flex' : 'flex'); }, function (props) { return (props.vertical ? 'column' : 'row'); }, function (props) { return props.vertical && 'display:block;'; });
export default FormControlWrapper;
var templateObject_1;
//# sourceMappingURL=FormControlWrapper.js.map